import host from '@/utils/request/host.js'
import { Dialog } from 'vant'

export const regDomainAndPics = new RegExp(
  /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}(:\d{3,6})?\/(pics\/)/,
  'ig'
)
/**
 * 判断当前path是否是链接、mail、tel类型
 * 主要Sidebar使用
 * @export isExternal
 * @param {String} path
 * @return {Boolean}
 */
export const isExternal = path => {
  return /^(https?:|mailto:|tel:)/.test(path)
}
/**
 * 输出图片的完整路径
 * 判断图片名称是否是url
 * url则直接返回，不是则返回 域名部分+图片名称
 *
 * @param {*} image
 * @return {*}
 */
export const outImageFullPath = image => {
  if (!image) {
    return
  }

  if (isExternal(image)) {
    return image.replace(regDomainAndPics, host.imageHost)
  } else {
    return `${host.imageHost}${image}`
  }
}

export const getKeyValueText = (code, value) => {
  let keyValueObj = localStorage.getItem('keyValue')
  if (!keyValueObj) {
    return ''
  }
  keyValueObj = JSON.parse(keyValueObj)
  const keyValues = keyValueObj?.[code]
  // 如果没值 返回空
  if (!keyValues) {
    return ''
  }
  const filterValue = keyValues.find(item => {
    return item.code === value
  })

  if (
    [
      'drug_form_meng',
      'drug_form',
      'measure_unit_meng',
      'measure_unit',
      'package_unit_meng',
      'package_unit',
      'chinese_drug_usage',
      'drug_usage_his',
      'drug_usage_meng_his',
      'frequence_his',
      'frequence'
    ].includes(code)
  ) {
    return filterValue ? filterValue.value : value
  } else {
    return filterValue ? filterValue.value : ''
  }
}

export const getBusinessValue = value => {
  if (!store.state.businessList) {
    return ''
  }
  const keyValues = store.state.businessList
  const filterValue = keyValues.filter(item => {
    return item.code === value
  })[0]

  return filterValue ? filterValue.count : ''
}

export const getKeyValue = key => {
  // if (!store.state.keyValue) {
  //   return ''
  // }
  // const data = store.state.keyValue
  let data = localStorage.getItem('keyValue')
  if (!data) {
    return ''
  }
  data = JSON.parse(data)
  return data[key] || ''
}

export const birthToAge = str => {
  if (str != null) {
    var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
    if (r == null) return false
    var d = new Date(r[1], r[3] - 1, r[4])
    if (d.getFullYear() == r[1] && d.getMonth() + 1 == r[3] && d.getDate() == r[4]) {
      var Y = new Date().getFullYear()

      return Y - r[1] + '岁'
    }
    return '输入的日期格式错误！'
  }
}

export const showModal = async data => {
  return new Promise(resolve => {
    Dialog({
      title: '提示',
      showCancelButton: data.showCancel === undefined ? true : data.showCancel,
      message: data.content,
      confirmButtonText: data.confirmText || '确定',
      confirmButtonColor: data.confirmColor || '#007aff',
      cancelButtonText: data.cancelText || '取消',
      cancelButtonColor: data.cancelColor || '#000000',
      ...data
    })
      .then(confirm => {
        resolve({
          resultCode: confirm === 'confirm' ? 0 : -1,
          content: data
        })
      })
      .catch(() => {
        resolve({
          resultCode: -1
        })
      })
  })
}

export const formatSymptomName = val => {
  if (!val) return '--'
  let msg = val ? JSON.parse(val) : []
  msg = msg.filter(data => {
    return !!data && data.symptomName
  })
  return msg[0]
    ? msg
        .map(item2 => {
          return item2.symptomName
        })
        .join('， ')
    : '--'
}

export const makePhoneCall = tel => {
  let input = document.createElement('a')
  input.style = 'position:fixed;left:-10000px;top:-10000px;opacity: 0;z-index:-1;'
  input.href = `tel:${tel}`
  input.click()
  setTimeout(() => {
    input = null
  }, 50)
}
